import React from 'react';
import { observer } from 'mobx-react';
import ExcelTableTds from './TableTds';
import CardStore from '../../stores/card';
import { getRowIndex } from '../../util/typeUtil';
import ModeExcel from '../../stores/card/ModeExcel';
import { syncLockedForDidMount } from "../../util/excelUtil";
import { isDragula } from '../../util/cubeUtil';

export interface ExcelTableCellDetailTBodyProps {
    excel?: ModeExcel;
    form: any
    card: CardStore;
    detail?: string;
    isButton?: boolean;
    isNeedPagination: boolean;
    isFixFieldDiv: boolean;
}

@observer
export default class ExcelTableCellDetailTBody extends React.Component<ExcelTableCellDetailTBodyProps, any> {
    constructor(props) {
        super(props);
        this.state = {
            needRowspan: true,
            flag: false
        }
    }

    componentWillUnmount() {
        this.setState({ flag: true });
    }

    renderTableTrs = () => {
        const { flag } = this.state;
        const { excel, form, card, detail, isNeedPagination, isFixFieldDiv,  } = this.props;
        const formValues = card.getDetailFormValues(form);

        const { edtitleinrow = '0', edtailinrow = '0', seniorset = '0', rows = [] } = excel || {};
        let headRow = parseInt(edtitleinrow, 0);
        let bodyRow = parseInt(edtailinrow, 0);
        let isSeniorset = seniorset == '1';
        let _rowhead = rows.slice();
        if (headRow == 0 || bodyRow == 0 || bodyRow <= headRow) {
            return ([[<div>对不起，表头标识、表尾标识设置异常，无法渲染明细！</div>]])
        }
        let isDrag = isDragula(card, detail);
        const pageSize = Number(form.pageSize);
        const pageNum = Number(form.pageNum);
        return excel ? _rowhead.map((row) => {
            const rowIndex: number = getRowIndex(row.id);

            let trs: JSX.Element[] = [];
            let rowspanJson = {};
            let mergeFields = excel.mergeFields;
            const supportLockedCol = excel.edlockedcol || -1;

            // mergeFields = [{fieldid:'field32356',fieldIndex:5}];
            if (rowIndex == headRow + 1) {
                //对明细表数据进行遍历，获取对应行的rowspan
                if (!flag) {
                    if (isNeedPagination) {
                        let count = mergeFields && mergeFields.count || 0;
                        for (let i = (pageSize * pageNum - pageSize); i <= (pageSize * pageNum - 1); i++) {
                            if (i < formValues.length) {
                                for (let j = 0.; j < count; j++) {
                                    if(mergeFields[j]===undefined){continue;}
                                    const ffieldid = 'field' + mergeFields[j].fieldid;
                                    if (card.fieldsProps && card.fieldsProps[ffieldid] === undefined) {
                                        continue;
                                    }
                                    const fieldObj = card.fieldsProps[ffieldid];
                                    const fieldViewOnly = fieldObj && fieldObj["isedit"];
                                    if ((fieldViewOnly == ''||fieldViewOnly == '0') && !isDrag) {//只读且未开启明细表拖动排序
                                        rowspanJson = this.getRowspan(formValues, i, (pageSize * pageNum - 1), mergeFields[j].fieldIndex, 'field' + mergeFields[j].fieldid, rowspanJson);
                                    }
                                }
                            }
                        }
                    } else {
                        //对明细表数据进行遍历，获取对应行的rowspan
                        // mergeFields = [{fieldid:'field32356',fieldIndex:5}];
                        for (let i = 0; i <= formValues.length; i++) {
                            if (i < formValues.length && mergeFields && mergeFields.count) {
                                for (let j = 0.; j < mergeFields.count; j++) {
                                    if(mergeFields[j]===undefined){continue;}
                                    const ffieldid = 'field' + mergeFields[j].fieldid;
                                    if (card.fieldsProps && card.fieldsProps[ffieldid] === undefined) {
                                        continue;
                                    }
                                    const fieldObj = card.fieldsProps[ffieldid];
                                    const fieldViewOnly = fieldObj && fieldObj["isedit"];
                                    if ((fieldViewOnly == ''||fieldViewOnly == '0') && !isDrag) {//只读且未开启明细表拖动排序
                                        rowspanJson = this.getRowspan(formValues, i, formValues.length, mergeFields[j].fieldIndex, 'field' + mergeFields[j].fieldid, rowspanJson);
                                    }

                                }

                            }
                        }
                    }
                }
                //位于表头表尾标识之间
                form.map((detailRow, j) => {
                    /***
                     * ljc -- 针对快速编辑，加个样式做判断,
                     * dtl_id 是uuid的时候加个class，暂时未保存的
                     * **/
                    const dtl_id = card.getDetailFormValues(detailRow)['dtl_id'] ||"";
                    let trClass = dtl_id.length> 30 ? "detail_data_editing":"";
                    //明细奇偶行加class方便二开重写
                    trClass += " " + ((j + 1) % 2 === 0 ? "detail_even_row detail_data_row" : "detail_odd_row detail_data_row");
                    if (detail && card.detailMap[detail] && card.detailMap[detail][`row_${detailRow.key}`]) {
                        const { needHide } = card.detailMap[detail][`row_${detailRow.key}`];
                        if (needHide === true)  //隐藏明细
                            trClass += " interface_hide";
                    }
                    if (isNeedPagination) { //新建，显示，编辑布局分页展示
                        if (j >= (pageSize * pageNum - pageSize) && j <= (pageSize * pageNum - 1)) {  //明细表数据分页显示控制
                            for (let i = rowIndex; i < bodyRow; i++) {
                                trs.push(<tr style={{ height: row.size }} className={trClass}
                                             data-rowindex={detailRow.key}>
                                    <ExcelTableTds ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTds@b8274w@${i}`} detailIndex={j} row={i}
                                                   card={card} excel={excel}
                                                   form={detailRow} detail={detail}
                                                   isFixFieldDiv={isFixFieldDiv}
                                                   rowspanJson={rowspanJson}
                                                   isTitle={false}
                                    />
                                </tr>)
                            }
                        }
                    } else {
                        for (let i = rowIndex; i < bodyRow; i++) {
                            /***判断是否行合并单元格 */
                            trs.push(<tr style={{ height: row.size }} className={trClass} data-rowindex={detailRow.key}>
                                <ExcelTableTds ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTds@di4wzg@${i}`}
                                    detailIndex={j}
                                    row={i}
                                    card={card}
                                    excel={excel}
                                    form={detailRow}
                                    detail={detail}
                                    isFixFieldDiv={isFixFieldDiv}
                                    rowspanJson={rowspanJson}
                                    isTitle={false}
                                />
                            </tr>)
                        }
                    }
                })
                if (detail && supportLockedCol > -1) {
                    const groupid = detail.replace('detail_', '');
                    syncLockedForDidMount(groupid);
                }
                return trs;
            } else if (rowIndex < headRow || (isSeniorset && rowIndex > bodyRow)) {//开启合计的情况
                if (rowIndex < headRow) {
                    return;
                }  //判断有合计的情况合计放在下面
                //对明细表数据进行遍历，获取对应行的rowspan
                let rowspanJson = {};
                trs.push(<tr style={{ height: row.size }}>
                    <ExcelTableTds ecId={`${this && this.props && this.props.ecId || ''}_ExcelTableTds@m783zm@${row.id}`} row={getRowIndex(row.id)} card={card} excel={excel} form={card.cubeForm}
                                   detail={detail} isFixFieldDiv={isFixFieldDiv} rowspanJson={rowspanJson} isTitle={true}/>
                </tr>)
            }
            return trs
        }) : [];
    }

    /**获取rowspan数据 */
    getRowspan = (formValues, i, maxIndex, fieldIndex, fieldId, rowspanJson) => {
        //  rowspanJson格式：  {1:[{fieldIndex:5,rowspan:'2'}，{fieldIndex:6,rowspan:'0'}]}
        //  rowspanJson[i]格式：  [{fieldIndex:5,rowspan:'2'}，{fieldIndex:6,rowspan:'0'}] -- 表示 第i行的设置

        //1.从当前行往下遍历,有相同，则rowspan值+1
        let rowspanvalue = 1;
        for (let j = i + 1; j <= maxIndex; j++) {
            if (j >= formValues.length) break;
            if (formValues[i]&&formValues[i][fieldId] && formValues[i][fieldId] != "" && (formValues[i][fieldId] === formValues[j][fieldId])) {
                // console.log("formValues[i][fieldId]:"+"i:"+i+"fieldId:"+fieldId+"value:"+formValues[i][fieldId]+" | | formValues[j][fieldId]:"+"j:"+j+"fieldId:"+fieldId+"value:"+formValues[j][fieldId]);
                //2.如果当前行数据与下一行数据相同，则当前行rowspan值+1，下一行rowspan值=0
                rowspanvalue++;

                //2.1当前行(第i行)rowspan值+1
                if (rowspanJson[i] == undefined) {
                    rowspanJson[i] = [];
                    let colIndexAndRowspan = {};
                    colIndexAndRowspan[fieldIndex] = rowspanvalue
                    rowspanJson[i].push(colIndexAndRowspan);
                } else {
                    let needAddField = true;
                    //多个列需要进行行合并时，需要遍历一次，找到需要修改的列
                    for (let a = 0; a < rowspanJson[i].length; a++) {

                        //如果当前td的rowspan已经被设置为0，则说明为被合并的行，不需要再做处理
                        if (rowspanJson[i][a][fieldIndex] == 0) {
                            needAddField = false;
                            break;
                        }
                        //若存在此列的值，则直接覆盖原数据
                        if (rowspanJson[i][a][fieldIndex] != undefined) {
                            rowspanJson[i][a][fieldIndex] = rowspanvalue;
                            needAddField = false;
                            break;
                        }
                    }
                    //若不存在此列的设置，则新增
                    if (needAddField) {
                        let colIndexAndRowspan = {};
                        colIndexAndRowspan[fieldIndex] = rowspanvalue
                        rowspanJson[i].push(colIndexAndRowspan);
                    }
                }

                //2.2被合并行(j=i+1)rowspan值 为0
                if (rowspanJson[j] == undefined) {
                    rowspanJson[j] = [];
                    let colIndexAndRowspan = {};
                    colIndexAndRowspan[fieldIndex] = 0
                    rowspanJson[j].push(colIndexAndRowspan);
                } else {
                    let needAddField = true;
                    //多个列需要进行行合并时，需要遍历一次，找到需要修改的列
                    for (let a = 0; a < rowspanJson[j].length; a++) {

                        //如果当前td的rowspan已经被设置为0，则说明为被合并的行，不需要再做处理
                        if (rowspanJson[j][a][fieldIndex] == 0) break;
                        //若存在此列的值，则直接覆盖原数据
                        if (rowspanJson[j][a][fieldIndex] != undefined) {
                            rowspanJson[j][a][fieldIndex] = 0;
                            needAddField = false;
                            break;
                        }
                    }
                    //若不存在此列的设置，则新增
                    if (needAddField) {
                        let colIndexAndRowspan = {};
                        colIndexAndRowspan[fieldIndex] = 0
                        rowspanJson[j].push(colIndexAndRowspan);
                    }
                }
            } else {
                break;
            }
            if (rowspanJson[0] != undefined && rowspanJson[0][1] != undefined && rowspanJson[0][1][3] != undefined) {
                // console.log("formValues[i][fieldId]:"+"i:"+i+"fieldId:"+fieldId+"value:"+formValues[i][fieldId]+" || || formValues[j][fieldId]:"+"j:"+j+"fieldId:"+fieldId+"value:"+formValues[j][fieldId]);
            }
        }
        return rowspanJson;
    }

    render() {
        return (
            <tbody className="detailtbody">
            {this.renderTableTrs()}
            </tbody>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/DetailTBody.tsx